@if ((settingsService.settings$ | async)?.pageReferences?.basketPage; as basketPage) {
    @if (basketPage?.url) {
        <a class="link" [routerLink]="basketPage?.url">
                <span
                    class="kk-visuallyhidden">{{ 'general.accessibility.goTo' | translateSafe: { destination: basketPage?.name } }}</span>
            <app-svg-icon aria-hidden="true" iconName="basket"></app-svg-icon>
            @if ((totalProductsCount$ | async); as totalProductsCount) {
                <app-badge behaviour="absolute" position="right" color="blue"
                           [label]="'checkout.confirmation.itemQuantity' | translateSafe">
                    {{ totalProductsCount | moreThan }}
                </app-badge>
            }
        </a>
    }
}
